module.exports = __webpack_public_path__ + "static/img/d3.4b37c405.jpg";